import Web3Store from "./Web3Store"

const web3Store = new Web3Store()

export default {
  web3Store
}
